import React from 'react';
import type { LocaleUtils } from 'react-day-picker/types/LocaleUtils';

import { Text } from '@rover/kibble/core';

export type Props = {
  classNames: {
    caption: string;
  };
  date: Date;
  locale: string;
  localeUtils: LocaleUtils;
  months: string[];
};

const DatePickerCaption = ({
  classNames,
  date,
  locale,
  localeUtils,
  months,
}: Props): JSX.Element => {
  const heading = months
    ? `${months[date.getMonth()]} ${date.getFullYear()}`
    : localeUtils.formatMonthTitle(date, locale);
  return (
    // react-day-picker renders the caption inside the month's role="grid", and iOS VoiceOver skips
    // any grid child that isn't a row or cell, so the month is exposed as a header row of its own.
    <div className={classNames.caption} role="row">
      <div role="columnheader" aria-colspan={7}>
        <div role="heading" aria-level={2}>
          <Text
            as="div"
            size="200"
            fontWeight="semibold"
            marginTop="3x"
            marginBottom="2x"
            marginX="2x"
          >
            {heading}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default DatePickerCaption;
